/* global lang, tinymce */
/*
 * #LAST_UPDATE 2019/10/30
 */

function keepAlive(loop, time) {
    siteAjax('/action/keepAlive', function() {
        if (loop) setTimeout(function() {keepAlive(loop, time);}, time ? time : 15 * 60000);
    });
}

function updateSVar(key, value, callback, blackout) {
    siteAjax("/action/sessionVariables?key=" + key + ((value) ? "&value=" + encodeURIComponent(value) : ""), 
            callback, null, blackout);
}
function updateMultiSVars(o, f) {
    var c = 0, k;
    for (k in o) {
        c++;
    }
    for (k in o) {
        updateSVar(k, o[k], function() {
            if (--c <= 0 && f) f();
        });
    }
}

/* #shared
function updateLabel(label, val, lang, callback, noload) {
    var ap = actionPath || "/action/";
    var res = encodeURIComponent(!val ? "`````" : val);
    ajax(ap + "addSiteLabel?lang=" + lang + "&key=" + label + "&value=" + res,
            !callback ? function(){} : callback, noload);
}
function updateLabelLangs(k, v, langs, f, noload) {
    var a = typeof langs === "string" ? langs.split(",") : langs;
    var successCd = a.length;
    var _complete = function() {
        successCd--;
        if (successCd <= 0) {
            ajaxBlackout(false);
            if (f) try {f();} catch (ex) {}
        }
    };
    if (!noload) {
        ajaxBlackout(true);
    }
    for (var i = 0; i < a.length; i++) {
        updateLabel(k, v, a[i], _complete, noload);
    }
}
function updateMultiLabels(o, lang, f, noload) {
    var c = 0, l = 0, timeout = 120, k;
    for (k in o) {
        updateLabel(k, o[k], lang, function(){c++;}, noload);
        l++;
    }
    var chk = function chk() {
        timeout -= 0.05;
        if (c < l) {
            if (timeout > 0) setTimeout(chk, 50);
        } else {
            if (f) f();
        }
    }();
}
*/

function saveSiteLabelContent(btn, id) {
    var txt = tinymce.get(id).getContent();
    var key = document.getElementById(id).getAttribute("data-key");
    
    var _complete = function(response) {
        var msg = btn.parentElement.querySelector(".msg-success");
        removeClass(msg, "none");
        setTimeout(function() {addClass(msg, "none");}, 3000);
    };
    
    updateLabel(key, txt, lang, _complete, true);
}
function saveEditContent(el, e) {
    e = e || window.event;
    if ((e.which || e.keyCode) === 27 || e.type === "blur") {
        el.onkeydown = null;
        el.onblur = null;
        el.contentEditable = false;
        el.style.background = "";
    }
}
function toggleEditContent(el) {
    el.onkeydown = function(event) {
        saveEditLabel(this, event);
    };
    el.onblur = function(event) {
        saveEditLabel(this, event);
    };
    el.contentEditable = true;
    el.style.background = "#add8e6";
    el.focus();
}

function forgotPassword() {
    var email = document.getElementById('forgotEmail').value;
    var validate = /\w@\w/;
    
    if(email.match(validate)) 
        ajax('/action/forgotPassword?email=' + encodeURIComponent(email), forgotPasswordComplete);
}
function forgotPasswordComplete() {
    document.getElementById("forgotEmailAddress").innerHTML = document.getElementById("forgotEmail").value;
    document.getElementById('forgotEmailMessage').style.display = "none";
    document.getElementById('passwordSent').style.display = "block";
}
function forgotPasswordRefresh() {
    document.getElementById('forgotEmailMessage').style.display = "block";
    document.getElementById('passwordSent').style.display = "none";
}

function switchTab(btn, id) {
    var tab = btn.parentElement,
        tabCls = tab.className,
        aCls = "active";

    if (tabCls.indexOf(aCls) === -1) {
        var ctn = document.getElementById(id),
            ctnCls = ctn.className,
            pos = getIndex(ctn) + 1,
            curTab = document.getElementsByClassName(tabCls + " " + aCls)[0],
            curCtn = document.getElementsByClassName(ctnCls + " " + aCls)[0];
        
        curTab.className = tabCls;
        curCtn.className = ctnCls;
        tab.className += " " + aCls;
        ctn.className += " " + aCls;
        replaceQueryState("zone", pos);
    }
}

function addNewEvent() {
    document.getElementById("eventForm-eventId").value = "";
    eventsWindowManagerOpen();
}
function reformEventsCalendar() {
    var ctner = document.getElementById("eventsContainer"),
        allCal = ctner.children,
        ci = 1,
        cal = allCal[ci],
        limit = 0;
    
    var _add = function(el) {
        var rows = el.getElementsByClassName("eventsCalTr"),
            btns = el.querySelectorAll(".eventsCalTdBtn>a"),
            sibId = "";
        
        for (var i = 0; i < rows.length; i++) {
            var cols, a, b, key, col, con;
            
            if (!rows[i].firstElementChild.innerHTML.trim()) {
                if (i === rows.length - 1) {
                    rows[i].style.display = "none";
                }
                if (i === 0) {
                    key = btns[0].href.substring(btns[0].href.indexOf("(") + 1).split(",");
                    sibId = "#events-mm-" + key[0] + "-" + key[1];
                    cols = rows[i].querySelectorAll("td:not([class])");
                    a = ctner.querySelector(sibId);
                    b = a.querySelectorAll(".eventsCalTd, .eventsCalTdToday, .eventsCalTdHighlight");

                    for (var j = cols.length; j > 0; j--) {
                        col = cols[cols.length - j];
                        con = b[b.length - j];

                        col.innerHTML = con.textContent || con.innerText;
                        col.className = "eventsCalTdFade";
                    }
                }
            }
            else if (!rows[i].lastElementChild.innerHTML.trim()) {
                key = btns[btns.length - 1].href.substring(btns[btns.length - 1].href.indexOf("(") + 1).split(",");
                sibId = "#events-mm-" + key[0] + "-" + key[1];
                cols = rows[i].querySelectorAll("td:not([class])");
                a = ctner.querySelector(sibId);
                b = a.querySelectorAll(".eventsCalTd, .eventsCalTdToday, .eventsCalTdHighlight");

                for (var j = 0; j < cols.length; j++) {
                    col = cols[j];
                    con = b[j];

                    col.innerHTML = con.textContent || con.innerText;
                    col.className = "eventsCalTdFade";
                }
            }
        }
        el.className = "eventsCalWrap";
    };
    var _respond = function(el) {
        var btns = el.querySelectorAll(".eventsCalTdBtn>a"),
            key = [],
            sibId = "";
        
        for (var i = 0; i < btns.length; i++) {
            key = btns[i].href.substring(btns[i].href.indexOf("(") + 1).split(",");
            sibId = "#events-mm-" + key[0] + "-" + key[1];
            if (!ctner.querySelector(sibId)) {
                var f = btns[i].href.replace("javascript:", "").replace(";", "");
                setTimeout(f);
                break;
            }
        }
        
        var __re = function() {
            var o = ctner.querySelector(sibId);
            
            if(o) {
                cal = allCal[ci];
                if (o.style.display !== "none" && cal.style.display !== "block") {
                    o.style.display = "none";
                    cal.style.display = "block";
                    setTimeout(function() {
                        __re();
                        _add(cal);
                    });
                }
            } else {
                setTimeout(__re);
            }
        };
        __re();
    };
    var _check = function() {
        allCal = ctner.children;
        for (var i = 0; i < allCal.length; i++) {
            if (allCal[i].style.display !== "none") break;
        }
        
        if (i === ci) {
            limit++;
            if (limit < 100) setTimeout(_check);
        } else {
            cal = allCal[i];
            ci = i;
            if (cal.className !== "eventsCalWrap") _respond(cal);
        }
    };
    
    _add(cal);
    
    ctner.onclick = function(e) {
        if (this.parentElement.className === "eventsCalTdBtn") {
            limit = 0;
            setTimeout(_check);
        }
    };
}

function wrapTextInnerDiv(ctnId/*, arguments*/) {
    var ctn = null;
    if (ctnId && ctnId !== "") {
        ctn = document.getElementById(ctnId);
    }
    for (var i = 1; i < arguments.length; i++) {
        var el = document.getElementById(arguments[i]);
        if (el) {
            if (ctn) {
                ctn.appendChild(el.parentElement);
            } else {
                addClass(el.parentElement, "wrap");
            }
        }
    }
}

function loadComponentStyle(id, style) {
    var comp = document.getElementById(id),
        currentStyle = comp.getAttribute("style");
    
    comp.setAttribute("style", currentStyle + style);
}
function setComponentStyle(a) {
    var ctn = getAncestor(a, "componentContainerDiv"),
        ap = a.parentElement,
        prop = ap.getAttribute("data-prop"),
        key = ap.getAttribute("data-key"),
        type = ap.getAttribute("data-type"),
        clr = "getComputedStyle" in window ? window.getComputedStyle(a.children[0], null).getPropertyValue(type) : a.children[0].currentStyle[type],
        style = prop + ":" + clr + ";";
        
    updateLabel(key, style, lang, function() {
        ctn.style[prop] = clr;
    }, true);
}

function activateZone(btn, label) {
    var status = btn.getElementsByClassName("zone-mod-actv-status")[0],
        activated = searchWord(status.className, "on") > -1,
        rspd = "responding";
    
    var _update = function() {
        var key0 = activated ? "on" : "off";
        var key1 = activated ? "off" : "on";
        replaceClass(status, key0, key1);
        btn.title = btn.getAttribute("data-" + key1);
        removeClass(btn, rspd);
    };
    
    if (searchWord(btn.className, rspd) === -1) {
        addClass(btn, rspd);
        updateLabelLangs(label, (activated ? "" : "true"), "en,fr", _update, true);
    }
}

function openPictogramSelect(key, id) {
    var el = document.getElementById(id),
        pic = el.children[0],
        sel = document.querySelector("#pictogramsWindow .pictogram");

    if (pic) {
        var cn = pic.getAttribute("class");
        var q = "#pictogramsWindow ." + cn.trim().replace(/\s/g, ".");
        sel = document.querySelector(q).parentElement;
    }
    selectPictogram(sel);
    document.getElementById("currentPictogramKey").value = key;
    document.getElementById("currentPictogramId").value = id;
    openWindow("pictogramsWindow");
}
function selectPictogram(el) {
    var cls = el.className,
        kc = "selected";

    if (cls.indexOf(kc) === -1) {
        var other = el.parentElement.querySelector("." + kc);
        if (other) removeClass(other, kc);
        addClass(el, kc);
    }
}
function confirmSelectedPictogram() {
    var key = document.getElementById("currentPictogramKey").value,
        id = document.getElementById("currentPictogramId").value,
        sel = document.querySelector("#pictogramsWindow .pictogram.selected"),
        pic = sel.children[0],
        val = "";

    if (pic) {
        val = pic.getAttribute("class");
        document.getElementById(id).innerHTML = pic.outerHTML;
    } else {
        document.getElementById(id).innerHTML = "";
    }
    updateLabelLangs(key, val, "en,fr");
    closeWindow("pictogramsWindow");
}

/* For EditableTextContent
 * tinymce.init({
        selector: ".custom-tiny",
        menubar: false,
        plugins: "paste link",
        toolbar: "undo redo | bold italic | alignleft aligncenter alignright alignjustify  | bullist | link",
        entity_encoding: "raw",
        paste_as_text: true,
        setup: function(ed) {
            tinymce_limitChars(ed);
        },
        init_instance_callback: function() {
            tinymce_charCounter(this);
        }
    });
 */
function tinymce_limitChars(ed) {
    var max = ed.getElement().maxLength;
    var _mem = "";
    if (!isNaN(max)) {
        var allow = [0, 8, 9, 20, 27, 35, 36, 37, 38, 39, 40, 44, 46, 110, 144];
        ed.on("keydown", function (ev) {
            _mem = this.getContent();
            if (allow.indexOf(ev.keyCode) !== -1 || ev.ctrlKey || ev.metaKey || this.contentWindow.getSelection().toString() !== "") {
                return true;
            }
            if (tinymce_getContentLength(this) + 1 > max) {
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            }
        });
        ed.on("keyup", function (ev) {
            var text = this.getContent();
            if (text.length > max) {
                this.setContent(_mem);
            }
            tinymce_updateCharCounter(this, text.length);
        });
    }
}
function tinymce_charCounter(ed) {
    if (!isNaN($('#' + ed.id).attr("maxlength"))) {
        $('#' + ed.id).prev().find('.mce-statusbar .mce-flow-layout').append('<div class="mce-char-count" style="text-align:right"></div>');
        tinymce_updateCharCounter(ed, tinymce_getContentLength(ed));
    }
}
function tinymce_updateCharCounter(el, len) {
    $('#' + el.id).prev().find('.mce-char-count').text(len + '/' + el.getElement().maxLength);
}
function tinymce_getContentLength(ed) {
    return ed.getContent().length;
}

/* #shared
function textLabelWindow(id, ctn, key) {
    var content = ctn.innerHTML;
    if (content === ctn.getAttribute("data-ignore")) {
        content = "";
    }
    document.getElementById(id + "_key").value = key;
    document.getElementById(id + "_value").value = content;
    tinymce.get(id + "_value").load();
    
    var prevCtn = document.getElementById(id + "_src");
    if (prevCtn) prevCtn.id = "";
    ctn.id = id + "_src";
    
    openWindow(id);
}
function submitTextLabel(id) {
    var key = document.getElementById(id + "_key").value,
        val = tinymce.get(id + "_value").getContent();

    updateLabel(key, val, lang, function(resp) {
        var ctn = document.getElementById(id + "_src");
        ctn.innerHTML = decodeURIComponent(resp.trim().replace(/\+/g, " "));
    });
    
    closeWindow(id);
}
function eraseTextLabel(id) {
    var key = document.getElementById(id + "_key").value;
    
    updateLabel(key, "", lang, function(resp) {
        var ctn = document.getElementById(id + "_src");
        ctn.innerHTML = decodeURIComponent(resp.trim().replace(/\+/g, " "));
    });
    
    closeWindow(id);
}
*/

function openFilePreviewPicker(e) {
    var btn = e.target || this,
        $popup = $(".file-preview-picker-popup" + btn.getAttribute("data-picker")),
        url = btn.getAttribute("data-value");
    
    // Save current edit button to global
    window.currentEditableBackgroundButton = btn;
    
    // If the value is empty, set it to the default value
    if (!url || url === "") {
        url = btn.getAttribute("data-default");
    }
    // Select and open the folder that contains the corresponding image file
    try {
        var path = url.substring(0, url.lastIndexOf("/")),
            name = url.substring(url.lastIndexOf("/") + 1),
            $file = $popup.find(".file-preview-picker-item[data-file-url='" + path + "'][data-value='" + name + "']"),
            $directory = $file.parent().parent();
        
        // Reset all of the items in the directory to default state
        $popup.find(".file-preview-picker-main-directory").removeClass("child-folder-open");
        $popup.find(".file-preview-picker-directory").removeClass("show");
        $popup.find(".file-preview-picker-item.selected").removeClass("selected");
        // Activate open folder
        if ($directory.hasClass("file-preview-picker-directory")) {
            $popup.find(".file-preview-picker-item.folder[data-directory-to-open='" + $directory.attr("data-directory") + "']").click();
        }
        // Activate select item
        $file.click();
    } catch (err) {
    }
    $popup.fadeIn(300);
    
    var $submit = $popup.find(".file-preview-picker-popup-accept-btn");
    // Make sure to bind the event just once to the submit button inside the popup
    if (!$submit.hasClass("save-editable-background")) {
        $submit.addClass("save-editable-background");
        $submit.on("click", function(e) {
            // Stop bubbling event to the button's parent ctn
            e.stopPropagation();
            var fileUrl = "",
                cebb = window.currentEditableBackgroundButton,
                selectedFile = $popup.find(".file-preview-picker-item.selected:not(.folder)")[0];
            
            if (selectedFile) {
                fileUrl = selectedFile.getAttribute("data-file-url") + "/" + selectedFile.getAttribute("data-value");
            }
            
            updateLabelLangs(cebb.getAttribute("data-key"), fileUrl, cebb.getAttribute("data-langs"), function() {
                    // Set the new value to the button's data
                    cebb.setAttribute("data-value", fileUrl);
                    // If nothing is selected, assign the default background image
                    cebb.parentElement.style.backgroundImage = "url('" + (!selectedFile ? cebb.getAttribute("data-default") : fileUrl) + "')";
            }, true);
                    
            $popup.fadeOut(300);
        });
    }
}

/*\
|*|
|*|  :: AJAX Form Submit Framework ::
|*|
|*|  https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest/Using_XMLHttpRequest
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntax:
|*|
|*|   AJAXSubmit(HTMLFormElement);
\*/
            
var AJAXSubmit = (function () {
    var error = false;
    var success = false;
    var forward = "";
    var upRate = 0; //Bps
    var initTime;
    
    function ajaxError() {
        /* console.log("AJAXSubmit - Error!"); */
        error = true;
    }

    function ajaxSuccess() {
        /* console.log("AJAXSubmit - Success!"); */
        //alert(this.responseText);
        /* you can get the serialized data through the "submittedData" custom property: */
        /* alert(JSON.stringify(this.submittedData)); */
        success = true;
    }
    
    function ajaxProgress(pe) {
        var fps = 50 / 3,
            nDataSize = JSON.stringify(this.submittedData).length,
            waitTime = new Date() - initTime,
            est = Math.round((nDataSize / upRate) * 1000),
            extractDemo = document.getElementById("abs1_cb_demo").checked,
            extractToc = document.getElementById("abs1_cb_toc").checked,
            t = (est + (extractDemo ? waitTime : 0) + (extractToc ? waitTime : 0)) / 99,
            c = 1,
            ctner = document.querySelector(".upload-progress-ctner"),
            loadValue = ctner.querySelector('.upload-progress-current .number'),
            loadBar = ctner.querySelector('.upload-progress-fill');
    
        var _update = function() {
            var angle = Math.round((c / 100) * 360),
                angle2 = Math.round(((c + 1) / 100) * 360),
                delta = (angle2 - angle) / (t / fps);
        
            if (success) {
                t = c === 100 ? 4 : 200;
                c = 100;
                delta = (360 - angle) / (t / fps);
                animateCirclePath(loadBar, angle, 360, delta);
                loadValue.textContent = c;
                setTimeout(function() {
                    location.href = forward;
                }, 200);
            } else {
                if (c < 99) {
                    animateCirclePath(loadBar, angle, angle2, delta);
                    loadValue.textContent = c;
                    c++;
                }
                if (!error) setTimeout(_update, t);
            }
        };
        _update();
    }

    function submitData(oData) {
        /* check upload speed before submitting */
        if (upRate <= 0) {
            setTimeout(function() {
                submitData(oData);
            }, 100);
            return false;
        }
        /* the AJAX request... */
        var oAjaxReq = new XMLHttpRequest();
        oAjaxReq.submittedData = oData;
        oAjaxReq.onloadstart = ajaxProgress;
        oAjaxReq.onload = ajaxSuccess;
        oAjaxReq.onerror = ajaxError;
        if (oData.technique === 0) {
            /* method is GET */
            oAjaxReq.open("get", oData.receiver.replace(/(?:\?.*)?$/, oData.segments.length > 0 ? "?" + oData.segments.join("&") : ""), true);
            oAjaxReq.send(null);
        } else {
            /* method is POST */
            oAjaxReq.open("post", oData.receiver, true);
            if (oData.technique === 3) {
                /* enctype is multipart/form-data */
                var sBoundary = "---------------------------" + Date.now().toString(16);
                oAjaxReq.setRequestHeader("Content-Type", "multipart\/form-data; boundary=" + sBoundary);
                oAjaxReq.sendAsBinary("--" + sBoundary + "\r\n" + oData.segments.join("--" + sBoundary + "\r\n") + "--" + sBoundary + "--\r\n");
            } else {
                /* enctype is application/x-www-form-urlencoded or text/plain */
                oAjaxReq.setRequestHeader("Content-Type", oData.contentType);
                oAjaxReq.send(oData.segments.join(oData.technique === 2 ? "\r\n" : "&"));
            }
        }
    }
    
    function upSpeedTest(dataString, iterations) {
        var xhr = new XMLHttpRequest(),
            url = location.href,
            cache = (url.indexOf("?") > -1 ? "&" : "?") + "cache=" + Math.random(),
            size = 1048576, //bytes
            data = genData(),
            t = 0,
            rep = iterations ? iterations : 0;
            
        xhr.onload = getSpeed;
        xhr.open("post", url + cache, true);
        //xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        t = new Date();
        xhr.send(data);

        function genData() {
            if (dataString) {
                return dataString;
            } else {
                var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
                    l = chars.length,
                    data = "";
                for (var i = 0; i < size; i++) {
                    data += chars.charAt(Math.floor(Math.random() * l));
                }
                return data;
            }
        }

        function getSpeed() {
            var tS = (new Date() - t) / 1000;
            upRate = Math.floor(size / tS);
            if (!success && rep > 0) 
                setTimeout(function() {
                    upSpeedTest(data, rep - 1);
                }, 
                tS < 2 ? 2000 : 0);
        }
    }

    function processStatus(oData) {
        if (oData.status > 0) {
            return;
        }
        /* the form is now totally serialized! do something before sending it to the server... */
        upSpeedTest();
        /* console.log("AJAXSubmit - The form is now serialized. Submitting..."); */
        submitData(oData);
    }

    function pushSegment(oFREvt) {
        this.owner.segments[this.segmentIdx] += oFREvt.target.result + "\r\n";
        this.owner.status--;
        processStatus(this.owner);
    }

    function plainEscape(sText) {
        /* how should I treat a text/plain form encoding? what characters are not allowed? this is what I suppose...: */
        /* "4\3\7 - Einstein said E=mc2" ----> "4\\3\\7\ -\ Einstein\ said\ E\=mc2" */
        return sText.replace(/[\s\=\\]/g, "\\$&");
    }

    function SubmitRequest(oTarget) {
        // Timestamp initiating request
        initTime = new Date();
        // Open loading screen
        var ctner = document.querySelector(".upload-progress-ctner");
        ctner.className = ctner.className.replace(" none", "");
        oTarget.querySelector(".absf-btn-ctner").className += " hidden";
        $('html, body').animate({
            scrollTop: $(ctner).offset().top
        }, 500);
        
        var nFile, sFieldType, oField, oSegmReq, oFile, bIsPost = oTarget.method.toLowerCase() === "post";
        /* console.log("AJAXSubmit - Serializing form..."); */
        this.contentType = bIsPost && oTarget.enctype ? oTarget.enctype : "application\/x-www-form-urlencoded";
        this.technique = bIsPost ? this.contentType === "multipart\/form-data" ? 3 : this.contentType === "text\/plain" ? 2 : 1 : 0;
        this.receiver = oTarget.action;
        this.status = 0;
        this.segments = [];
        var fFilter = this.technique === 2 ? plainEscape : escape;
        for (var nItem = 0; nItem < oTarget.elements.length; nItem++) {
            oField = oTarget.elements[nItem];
            if (!oField.hasAttribute("name")) {
                continue;
            }
            if (oField.getAttribute("name") === "pageName") {
                forward = oField.value;
            }
            sFieldType = oField.nodeName.toUpperCase() === "INPUT" ? oField.getAttribute("type").toUpperCase() : "TEXT";
            if (sFieldType === "FILE" && oField.files.length > 0) {
                if (this.technique === 3) {
                    /* enctype is multipart/form-data */
                    for (nFile = 0; nFile < oField.files.length; nFile++) {
                        oFile = oField.files[nFile];
                        oSegmReq = new FileReader();
                        /* (custom properties:) */
                        oSegmReq.segmentIdx = this.segments.length;
                        oSegmReq.owner = this;
                        /* (end of custom properties) */
                        oSegmReq.onload = pushSegment;
                        this.segments.push("Content-Disposition: form-data; name=\"" + oField.name + "\"; filename=\"" + oFile.name + "\"\r\nContent-Type: " + oFile.type + "\r\n\r\n");
                        this.status++;
                        oSegmReq.readAsBinaryString(oFile);
                    }
                } else {
                    /* enctype is application/x-www-form-urlencoded or text/plain or method is GET: files will not be sent! */
                    for (nFile = 0; nFile < oField.files.length; this.segments.push(fFilter(oField.name) + "=" + fFilter(oField.files[nFile++].name)))
                        ;
                }
            } else if ((sFieldType !== "RADIO" && sFieldType !== "CHECKBOX") || oField.checked) {
                /* field type is not FILE or is FILE but is empty */
                this.segments.push(
                        this.technique === 3 ? /* enctype is multipart/form-data */
                        "Content-Disposition: form-data; name=\"" + oField.name + "\"\r\n\r\n" + oField.value + "\r\n"
                        : /* enctype is application/x-www-form-urlencoded or text/plain or method is GET */
                        fFilter(oField.name) + "=" + fFilter(oField.value)
                        );
            }
        }
        processStatus(this);
    }
    
    function checkAlert(oField, oFieldCtn) {
        if(oField.value.trim() !== "") {
            $(oFieldCtn).removeClass("alert");
        } else {
            setTimeout(function() {
                checkAlert(oField, oFieldCtn);
            }, 160);
        }
    }
    
    function checkFields(oForm) {
        var oReqFields = oForm.querySelectorAll(".required");
        for (var i = 0; i < oReqFields.length; i++) {
            var oField = oReqFields[i];
            var oFieldCtn = oField.parentElement;
            
            if (oField.value.trim() === "") {
                $(oFieldCtn).addClass("alert");
                checkAlert(oField, oFieldCtn);
            } else {
                $(oFieldCtn).removeClass("alert");
            }
        }
        return oForm.getElementsByClassName("alert").length < 1;
    }

    return function (oFormElement) {
        if (!oFormElement.action) {
            return;
        }
        var erms = document.getElementsByClassName("errmsg-nofiles")[0];
        if (!checkFields(oFormElement)) {
            erms.style.display = "block";
            return;
        } else {
            erms.style.display = "none";
        }
        new SubmitRequest(oFormElement);
    };

})();

function foc(inp) {
    if (inp.value && inp.value !== "") {
        addClass(inp, "focused");
    } else {
        removeClass(inp, "focused");
    }
    setTimeout(function() {foc(inp);}, 160);
}

function confirmNewPassword(pwEl, pwEl2) {
    var p = pwEl.value;
    var p2 = pwEl2.value;
    return p === p2 && p.length !== 0;
}

function chkEmail(value) {
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return filter.test(value);
}
function chkPhoneNumber(value) {
    //var re = /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-|\.)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;
    var re = /^(((\+?[0-9]{1,3} )?\([0-9]{3}\) [0-9]{3}\-[0-9]{4}|(\+?[0-9]{1,3}[\-])?[0-9]{3}\-[0-9]{3}\-[0-9]{4}|(\+?[0-9]{1,3}[\.])?[0-9]{3}\.[0-9]{3}\.[0-9]{4})|\+?[0-9 ]{10,20})( ?(x|ext|extension)[\. ]?\d{1,6})?$/;
    return re.test(value);
}
function sanitizePhone(value) {
    var raw = value.substring(0).replace(/[\+\(\)\.\- ]/g, "");
    try {
        var ext = raw.search(/(extension|ext|x)/);
        if (ext > -1) raw = raw.substring(0, ext);
        var group = [raw.substr(-7, 3), raw.substr(-4)];
        if (raw.length > 7) group.unshift(raw.substr(-10, 3));
        if (raw.length > 10) group.unshift(raw.substr(0, raw.length - 10));
        return (value.match(/\+/) ? "+" : "") + group.join("-");
    } catch (ex) {
        return raw;
    }
}
function chkNameField(value) {
    //var re = /^[a-z\u00C0-\u024F'\.\-\s]*$/i;
    var re = /^(?:[a-z\u00C0-\u024F]+['\.\- ]?[a-z\u00C0-\u024F]?)+$/i;
    return re.test(value);
}
function sanitizeName(value) {
    var aa = value.split(" ");
    for (var i = 0; i < aa.length; i++) {
        var ab = aa[i].split("-");
        for (var j = 0; j < ab.length; j++) {
            var ac = ab[j].split(".");
            for (var k = 0; k < ac.length; k++) {
                var ad = ac[k];
                ac[k] = ad.substr(0, 1).toUpperCase() + ad.substr(1).toLowerCase();
            }
            ab[j] = ac.join(".");
        }
        aa[i] = ab.join("-");
    }
    return aa.join(" ");
}
/* #shared
function canadaPC(code) {
    var filter = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
    return filter.test(code);
}
function usaZIP(code) {
    var filter = /^\d{5}([ \-]\d{4})?$/;
    return filter.test(code);
}
*/

function chkReqFields(f) {
    var $form = typeof f === "string" ? $("#" + f) : $(f),
        chk = true,
        chkbox = true,
        aNumber = true;

    $form.find(".required").each(function () {
        var $inp = $(this),
            type = $inp.attr("type"),
            name = $inp.attr("name"),
            val = $inp.val();

        switch (type) {
            case "radio":
            case "checkbox":
                // At least one of the required boxes is checked
                if ($form.find("[name='" + name + "']:checked").length) {
                    $inp.removeClass("alert-o");
                    chkbox = true;
                } else {
                    $inp.addClass("alert-o");
                    $inp.change(chkCheckField);
                    chkbox = false;
                }
                break;

            default:
                if (!$inp.hasClass("inp-num")) {
                    $inp.val(val.trim());
                    val = val.replace(/\s/g, "");
                    if (type === "email" || name === "email") {
                        if (!chkEmail(val)) {
                            $inp.addClass("alert");
                            $inp.blur(chkAlertField);
                            chk = false;
                            $form.find(".errmsg-email").css("display", "block");
                        } else {
                            $inp.removeClass("alert");
                            $form.find(".errmsg-email").css("display", "none");
                        }
                    } else {
                        if (val === "" || val.length === 0) {
                            $inp.addClass("alert");
                            $inp.blur(chkAlertField);
                            chk = false;
                        } else {
                            $inp.removeClass("alert");
                        }
                    }
                    break;
                }
                // It has a number class, go down in the next case

            case "number":
                var x = parseInt(val),
                    minX = $inp.attr("min") && x < $inp.attr("min");

                if (isNaN(x) || minX || /\D/.test(x)) {
                    $inp.addClass("alert");
                    $inp.blur(chkDigitField);
                    aNumber = false;
                } else {
                    $inp.removeClass("alert");
                }
                break;
        }
    });
    $form.find(".errmsg-emptyfields").css("display", chk ? "none" : "block");
    $form.find(".errmsg-agree").css("display", chkbox ? "none" : "block");

    return chk && chkbox && aNumber;
}
function chkDigitField(e) {
    var $field = $(this || e.currentTarget || e.srcElement),
        val = parseInt($field.val());
    
    if(!(isNaN(val) && /\D/.test(val))) {
        $field.removeClass("alert");
        $field.off(e.type, null, chkDigitField);
        
        if($field.parents("form").find(".alert").length === 0) {
            $field.parents("form").find(".errmsg-emptyfields").hide();
        }
    }
}
function chkAlertField(e) {
    var $field = $(this || e.currentTarget || e.srcElement),
        val = $field.val().replace(/\s/g, "");
    
    if(val !== "" && val.length !== 0) {
        $field.removeClass("alert");
        $field.off(e.type, null, chkAlertField);
        
        if($field.parents("form").find(".alert").length === 0) {
            $field.parents("form").find(".errmsg-emptyfields").hide();
        }
    }
}
function chkCheckField(e) {
    var $field = $(this || e.currentTarget || e.srcElement);
    if ($field[0].checked) {
        $field.removeClass("alert-o");
        $field.off(e.type, null, chkCheckField);
    }
}
function chkForm(id) {
    if(chkReqFields(id)) {
        ajaxBlackout(true);
        document.getElementById(id).submit();
    }
}
function chkFormO(form) {
    if (chkReqFields(form)) {
        ajaxBlackout(true);
        form.submit();
    }
}
function chkContactForm(nfields) {
    if (chkReqFields("#contactForm-Container")) {
        sendContactFormEmail(false, nfields);
    }
}
function chkRegstrForm(id) {
    var valid = chkReqFields(id),
        form = document.getElementById(id),
        pw = getElementByName(form, "password"),
        pwc = getElementByName(form, "passwordConfirm");
    
    if(pw.value !== pwc.value && pw.value.length !== 0) {
        pwc.className += " alert";
        form.querySelector(".errmsg-pwconfirm").style.display = "block";
        valid = false;
    } 
    else if(pwc.value.length !== 0) {
        pwc.className = pwc.className.replace("alert", "").trim();
        form.querySelector(".errmsg-pwconfirm").style.display = "none";
    }
    
    return valid;
}
function chkAccForm(form) {
    var $form = $(form);
    var valid = true;
    
    $form.find("input, textarea, select").each(function() {
        var $inp = $(this);
        var val = $inp.val().trim().replace(/\s+/g, " ");
        var isEmpty = val === "";
        var pass = true;

        switch ($inp.attr("name")) {
            case "firstName": 
            case "lastName": 
            case "city":
                pass = chkNameField(val) && !isEmpty;
                if (pass) val = sanitizeName(val);
                $inp.val(val);
                break;
            case "phone":
            case "phoneNumber":
                pass = chkPhoneNumber(val);
                if (pass) val = sanitizePhone(val);
                $inp.val(val);
                break;
            case "email":
                val = val.toLowerCase();
                pass = chkEmail(val);
                $inp.val(val);
                break;
            case "postalCode":
            case "zip":
                val = val.toUpperCase().replace(" ", "");
                pass = !isEmpty;
                if (pass) {
                    var country = $form.find("[name='country']").val();
                    if (country === "CA" || country === "CAN") pass = canadaPC(val);
                    if (country === "US" || country === "USA") pass = usaZIP(val);
                }
                break;
            case "password2":
            case "passwordConfirm":
                pass = confirmNewPassword($form.find("[name='password']")[0], $inp[0]);
                if (!pass) {
                    $form.find(".errmsg-pwconfirm").show();
                } else {
                    $form.find(".errmsg-pwconfirm").hide();
                }
                break;
            default:
                pass = !isEmpty || !$inp.hasClass("required");
                break;
        }
        
        if (!pass) {
            valid = false;
            $inp.addClass("alert");
        } else {
            $inp.removeClass("alert");
        }
    });
    
    return valid;
}
// PMIAccount
function chkPMIAccForm(form) {
    var $form = $(form);
    var valid = true;
    
    $form.find(".inputField, .country-select, .selected-province").each(function() {
        var $inp = $(this);
        var $err = $inp.closest(".field").find(".errorMessage");
        var val = $inp.val().trim().replace(/\s+/g, " ");
        var isEmpty = val === "";
        var pass = true;

        switch ($inp.attr("name")) {
            case "pmiNumber":
                if (!isEmpty) pass = !isNaN(val);
                break;
            case "firstName": 
            case "lastName": 
            case "city":
                pass = chkNameField(val) && !isEmpty;
                if (pass) val = sanitizeName(val);
                break;
            case "phone":
            case "phoneNumber":
                pass = chkPhoneNumber(val);
                if (pass) val = sanitizePhone(val);
                break;
            case "email":
                val = val.toLowerCase();
                pass = checkEmail(val);
                break;
            case "postalCode":
                val = val.toUpperCase().replace(" ", "");
                pass = !isEmpty;
                if (pass) {
                    var country = $("#acntCountry").val();
                    if (country === "CA") pass = canadaPC(val);
                    if (country === "US") pass = usaZIP(val);
                }
                break;
            case "street2":
            case "password": 
                break;
            default:
                pass = !isEmpty;
                break;
        }
        $inp.val(val);
        if (!pass) {
            valid = false;
            $inp.addClass("error");
            $err.show();
        } else {
            $inp.removeClass("error");
            $err.hide();
        }
    });
    if (valid) $form[0].submit();
}
function chkCCForm(id) {
    var valid = true,
        form = document.getElementById(id),
        type = form.querySelector(".cc-types"),
        inputs = form.querySelectorAll(".required"),
        selY = form.querySelector(".cc-expy"),
        selM = form.querySelector(".cc-expm"),
        yy = selY.value,
        mm = selM.value,
        currY = selY.getAttribute("data-now"),
        currM = selM.getAttribute("data-now");
    
    if (type.value === "") {
        type.style.border = "1px solid #cc0000";
        type.nextElementSibling.style.display = "block";
        valid = false;
    } else {
        type.style.border = "";
        type.nextElementSibling.style.display = "none";
    }
    for (var i = 0; i < inputs.length; i++) {
        var a = inputs[i].value;
        var nO = /^[0-9]*$/.test(a);
        var ex = /phone|email/.test(inputs[i].name);
        var sc = (inputs[i].name === "cvv2");
        var msg = inputs[i].nextElementSibling;
        
        if(!a || !nO && !ex || sc && a.length < 3) {
            inputs[i].style.borderColor = "#cc0000";
            if(msg) msg.style.display = "block";
            valid = false;
        } else {
            inputs[i].style.borderColor = "";
            if(msg) msg.style.display = "none";
        }
    }
    if(parseInt(mm) < parseInt(currM) && yy === currY) {
        form.querySelector(".expError").style.display = "block";
        valid = false;
    } else {
        form.querySelector(".expError").style.display = "none";
    }
    
    if (valid) {
        ajaxBlackout(true);
        form.submit();
    }
}
function chkCCForm2($form) {
    var invalid = false,
        expired = false,
        $expm = $form.find("[name='expMM']"),
        $expy = $form.find("[name='expYY']"),
        regexNumber = /^[0-9]*$/,
        errCls = "error";

    $form.find(".required").each(function() {
        var pass = true;
        var val = this.value;
        if (val === "") {
            pass = false;
        } else {
            switch (this.name) {
                case "accnt":
                    if (!regexNumber.test(val)) pass = false;
                    break;
                case "cvv2":
                    if (!regexNumber.test(val) && val.length < 3) pass = false;
                    break;
            }
        }
        if (!pass) {
            invalid = true;
            $(this).addClass(errCls);
        } else {
            $(this).removeClass(errCls);
        }
    });

    if (parseInt($expm.val()) < parseInt($expm.parents(".item-row").attr("data-now")) && $expy.val() === $expy.parents(".item-row").attr("data-now")) {
        expired = true;
        $expm.addClass(errCls);
    } else {
        $expm.removeClass(errCls);
    }

    if (invalid || expired) {
        $form.addClass("has-error");
    } else {
        $form.removeClass("has-error");
    }
    if (invalid) {
        $form.find(".js-form-error-message.cc-invalid").slideDown(300);
    } else {
        $form.find(".js-form-error-message.cc-invalid").slideUp(300);
    }
    if (expired) {
        $form.find(".js-form-error-message.cc-expired").slideDown(300);
    } else {
        $form.find(".js-form-error-message.cc-expired").slideUp(300);
    }

    return !invalid && !expired;
}

function changeSelect(sel) {
    var cl = sel.className;
    
    if (sel.value === "") {
        sel.className = cl.replace(/selected/g, "").trim();
    } 
    else if (cl.indexOf("selected") === -1) {
        sel.className += " selected";
    }
}
function changeSelects(co) {
    for (var i = 0; i < co.length; i++) {
        changeSelect(co[i]);
        co[i].addEventListener("change", function() {
            changeSelect(this);
        });
    }
}

function getFileName(input, id){
    var file = input.value;
    var fileName = file.split("\\");
    document.getElementById(id).innerHTML = fileName[fileName.length-1];
}
function verifyFileType(file) {
    var MIME_FILE = {
        ".doc"  : "application/msword",
        ".docx" : "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ".pdf"  : "application/pdf",
        ".ppt"  : "application/vnd.ms-powerpoint",
        ".pptx" : "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ".odp"  : "application/vnd.oasis.opendocument.presentation",
        ".ods"  : "application/vnd.oasis.opendocument.spreadsheet",
        ".odt"  : "application/vnd.oasis.opendocument.text",
        ".jfif" : "image/jpeg",
        ".jpe"  : "image/jpeg",
        ".jpeg" : "image/jpeg",
        ".jpg"  : "image/jpeg",
        ".pjp"  : "image/jpeg",
        ".pjpeg": "image/jpeg"
    };
    var filename = typeof file === "string" ? file : file instanceof Blob ? file.name : file.value,
        ext = filename.substr(filename.lastIndexOf("."));
    
    return MIME_FILE[ext];
}
function validateImageFile(e, el) {
    var MIME_IMAGE = {
        ".jpeg" : "image/jpeg",
        ".jpg"  : "image/jpeg",
        ".gif"  : "image/gif",
        ".png"  : "image/png"
    };
    var MIME_VIDEO = {
        ".mp4"  : "video/mp4",
        ".webm" : "video/webm",
        ".ogg"  : "video/ogg",
        ".ogv"  : "video/ogv",
        ".mov"  : "video/mov"
    };
    
    var inp = el || e.target,
        file = inp.files[0],
        ext = file.name.substr(file.name.lastIndexOf(".")).toLowerCase(),
        lang = document.documentElement.lang,
        valid = true;

    try {
        if (!(ext in MIME_IMAGE || ext in MIME_VIDEO) && inp.accept === "") {
            valid = false;
            throw lang === "fr" ? "Fichier invalid" : "Invalid file";
        }
        if (file.size < 160 || (file.size > 10485760 && !(ext in MIME_VIDEO))) {
            valid = false;
            throw lang === "fr" ? "Le fichier est trop lourd ou trop l\xE9ger" : "File size is too large or too small";
        }
    } catch (err) {
        popErrorSiteComplete(err);
    }

    return valid;
}

/* #shared
function initChangeStates(cSelects) {
    if (cSelects.length !== 0) {
        for (var i = 0; i < cSelects.length; i++) {
            var cs = cSelects[i];
            changeStates(cs.value, cs.form);
        }
    }
}
function changeStates(value, form) {
    try {
        var f = form ? form : document,
            p = f.querySelector(".province-select"),
            s = f.querySelector(".state-select"),
            o = f.querySelector(".other-province-select"),
            r = f.querySelector(".real-province"),
            req = r.className.indexOf("required") === -1 ? "" : " required";

        var reset = function(el) {
            if (req !== "") el.className = el.className.replace(req, "");
            el.style.display = "none";
            el.tabIndex = -1;
        };
        var change = function(el) {
            el.removeAttribute("tabindex");
            el.style.display = "block";
            el.className += req;
            el.onchange();
        };

        reset(p);
        reset(s);
        reset(o);
        switch (value.toUpperCase()) {
            case "CA":
            case "CAN":
                change(p);
                break;
            case "US":
            case "USA":
                change(s);
                break;
            default:
                change(o);
                break;
        }
    } catch (ex) {
        try {// Old function            
            var f = form ? form : document;
            var p = f.querySelector(".province-select"),
                s = f.querySelector(".state-select"),
                o = f.querySelector(".other-province-select"),
                v = value.toUpperCase();

            p.className = p.className.replace("required", "").trim();
            s.className = s.className.replace("required", "").trim();
            o.className = o.className.replace("required", "").trim();
            if(v === "CA" || v === "CAN") {
                p.style.display = "block";
                s.style.display = "none";
                o.style.display = "none";
                p.className += " required";
                p.onchange();
            }
            else if(v === "US" || v === "USA") {
                p.style.display = "none";
                s.style.display = "block";
                o.style.display = "none";
                s.className += " required";
                s.onchange();
            }
            else {
                p.style.display = "none";
                s.style.display = "none";
                o.style.display = "block";
                o.className += " required";
                o.onchange();
            }
        } catch (noSelects) {
        }
    }
}
*/

function toggleAccordion(el) {
    $(el).toggleClass("active");
    $(el).next().slideToggle();
}

function setCoreMinHeight() {
    try {
        var core = document.getElementsByClassName("core")[0];
        if (core.parentElement.clientHeight < winH) {
            core.style.minHeight = (winH - document.getElementsByClassName("header")[0].clientHeight - document.getElementsByClassName("footer")[0].clientHeight) + "px";
        }
    } catch (err) {
    }
}

function levitate(sel) {
    var comps = document.querySelectorAll(sel),
        oy = 0;

    var fn = function() {
        oy = window.pageYOffset + window.innerHeight;

        for (var i = comps.length - 1; i >= 0; i--) {
            var comp = comps[i],
                y = comp.offsetTop + window.innerHeight / 6;

            if (oy >= y && !hasClass(comp, "levitated")) {
                addClass(comp, "levitated");
            } else if (oy < comp.offsetTop) {
                removeClass(comp, "levitated");
            }
        }
    };

    if (comps.length > 0) {
        fn();
        window.addEventListener("scroll", fn);
    }
}

function makeEllipsis(el, maxLines) {
    if (!el) return;

    if (!maxLines) maxLines = 1;

    var str = el.textContent,
        spaceIndex = str.lastIndexOf(" "),
        lineHeight = window.getComputedStyle(el).lineHeight,
        maxHeight = parseFloat(lineHeight) * maxLines,
        curHeight = el.clientHeight - 1;

    if (maxHeight <= 0) return;

    while (curHeight > maxHeight && spaceIndex > -1) {
        str = str.substring(0, spaceIndex) + "...";
        spaceIndex = str.lastIndexOf(" ");
        el.textContent = str;
        curHeight = el.clientHeight - 1;
    }
}

function reloadSearchDate(startParam, startDate, endParam, endDate) {
    window.location.search = "?" + startParam + "Day=" + startDate.substr(0, 2) 
            + "&" + startParam + "Month=" + (parseInt(startDate.substr(3, 2)) - 1)
            + "&" + startParam + "Year=" + startDate.substr(6, 4)
            + "&" + endParam + "Day=" + endDate.substr(0, 2) 
            + "&" + endParam + "Month=" + (parseInt(endDate.substr(3, 2)) - 1)
            + "&" + endParam + "Year=" + endDate.substr(6, 4);
}

function devin() {
    var a = localStorage.getItem("dev-con");
    if (a === null) return;
    var b = sessionStorage.getItem(a);
    if (b === null) return;
    siteAjax("/action/login?ajax=true&username="+encodeURIComponent(a)+"&password="+encodeURIComponent(atob(b)), function() {console.log(a + " connected");}, null, false, "POST");
}